/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskForm5500BasicResponse } from './ExecRiskForm5500BasicResponse';
import {
    ExecRiskForm5500BasicResponseFromJSON,
    ExecRiskForm5500BasicResponseFromJSONTyped,
    ExecRiskForm5500BasicResponseToJSON,
} from './ExecRiskForm5500BasicResponse';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedForm5500BasicResponse
 */
export interface ExecRiskPaginatedForm5500BasicResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500BasicResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskForm5500BasicResponse>}
     * @memberof ExecRiskPaginatedForm5500BasicResponse
     */
    results: Array<ExecRiskForm5500BasicResponse>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedForm5500BasicResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500BasicResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500BasicResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedForm5500BasicResponse interface.
 */
export function instanceOfExecRiskPaginatedForm5500BasicResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedForm5500BasicResponseFromJSON(json: any): ExecRiskPaginatedForm5500BasicResponse {
    return ExecRiskPaginatedForm5500BasicResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedForm5500BasicResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedForm5500BasicResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskForm5500BasicResponseFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedForm5500BasicResponseToJSON(value?: ExecRiskPaginatedForm5500BasicResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskForm5500BasicResponseToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

